import { call, take, put } from 'redux-saga/effects';
import axios               from 'axios';
import { SET_USER_INFO }   from '../actions';

const userInfoEndpoint = `https://www.yisumatica.org.il/chk_session`;

function* getUserInfo() {
  while(true) {
    try {

        yield take('GET_USER_INFO_SAGA');

        if (process.env.NODE_ENV === 'development') {

            const payload = {
              userId:      'test',
              userLogedIn: 'true'
            }

            yield put(SET_USER_INFO( payload ))
            return
        }

        console.log('getting user info')
        
        const userInfo = yield call( axios.get, userInfoEndpoint);
        
        const infoStr = userInfo.data;

        console.log('userInfo.data   : ',userInfo.data)

        const n1 = infoStr.search('name=')
        const n2 = infoStr.search('&mail=')
        const n3 = infoStr.search('&user=')
        const n4 = infoStr.search('&semel_mosad=')

        let name = '', email = '', logedIn = '';

        if (n1 !== -1 && n2 !== -1 && n3 !== -1 && n4 !== -1) {
          name  = infoStr.slice(n1 + 5, n2);
          email = infoStr.slice(n2 + 6, n3);

          console.log('name    : ',name)
          console.log('email   : ',email)
        }        

        if (email.length) { logedIn = 'true' }
        else { logedIn = 'false' }

        const payload = {
          userId:      email,
          userLogedIn: logedIn
        }

        yield put(SET_USER_INFO( payload ))

    }
    catch(err) {
      const payload = {
        userId:      '',
        userLogedIn: 'false'
      }

      yield put(SET_USER_INFO( payload ))
      console.log('err  :  '+err);

    }
    finally {}
  }
}


export default getUserInfo;
